export const requiredTextStyle = (appTheme) => ({
  fontSize: "12px",
  color: appTheme.mutedText,
  marginTop: "-4px"
});

export const inputStyle = (appTheme) => ({
  padding: "14px 16px",
  borderRadius: "16px",
  border: appTheme.accentBorder,
  background: appTheme.inputBackground,
  fontSize: "14px",
  color: appTheme.primaryText,
  outline: "none",
  width: "92%",
  margin: "0 auto",
  display: "block",
  boxSizing: "border-box",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)"
});

export const quickActionButtonStyle = (appTheme, isMobile) => ({
  minHeight: "44px",
  padding: isMobile ? "0 10px" : "0 16px",
  borderRadius: "999px",
  border: appTheme.pillBorder,
  background: appTheme.pillBackground,
  color: appTheme.primaryText,
  fontWeight: "700",
  fontSize: isMobile ? "13px" : "14px",
  cursor: "pointer",
  whiteSpace: "nowrap",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  transition: "all 0.18s ease"
});

export const smallSecondaryButtonStyle = (appTheme, hoveredButton, hoverKey) => ({
  padding: "6px 10px",
  borderRadius: "10px",
  border: appTheme.pillBorder,
  cursor: "pointer",
  background: appTheme.pillBackground,
  color: appTheme.primaryText,
  transform: hoveredButton === hoverKey ? "translateY(-1px)" : "none",
  transition: "all 0.15s ease"
});